module.exports = "<block\n    cols=\"150px 1fr 150px\"\n    rows=\"50px 1fr 30px\"\n    pattern=\"header header header, navigation main ads, footer footer footer\"\n    style=\"height: 300px;\">\n    <block slot=\"header\" class=\"area-0\"></block>\n    <block slot=\"navigation\" class=\"area-1\"></block>\n    <block slot=\"main\" class=\"area-2\"></block>\n    <block slot=\"ads\" class=\"area-3\"></block>\n    <block slot=\"footer\" class=\"area-4\"></block>\n</block>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/example/6-holygrail.html
// module id = 211
// module chunks = 1